import React from "react";
import './css/style.css';
import moment from 'moment';
import translateString from "../utils/Locales";

let t = translateString;

export default class ScheduleView extends React.Component {

    constructor(){
        super();
        this.meetings = [];
        this.scheduleRef = React.createRef();


        this.start = 0;
        this.state = {
            popupVisible: false,
            x: 0,
            y: 0,
            mouseX: 0, 
        }
    }

    componentDidMount(){

        this.currentEventStartHour = 8;
        this.currentEventStartMinutes = 0;
        this.currentEventEndHour = 22;
        this.currentEventEndMinutes = 0;

        this.timePrecision = this.props.timePrecision;
        this.timeDivisor = 60 / this.timePrecision;
        
        this.labelsTime = [];
        for (var i = parseInt(this.currentEventStartHour) + 1; i < parseInt(this.currentEventEndHour); i++){
            let label = i+":00";
            let position = (this.currentEventStartMinutes / 60) + (i - parseInt(this.currentEventStartHour) - (this.currentEventStartMinutes > 0 ? 1 : 0));
            this.labelsTime.push({
                label: label,
                position: position
            });
        }

        this.meetings = this.props.meetings;
        this.breaks = this.props.breaks;
        this.date = this.props.date;
        this.type = this.props.type;
        this.subject = this.props.subject;

        let endTimestamp = parseInt(this.currentEventEndHour) * 60 + parseInt(this.currentEventEndMinutes);
        let startTimestamp = parseInt(this.currentEventStartHour) * 60 + parseInt(this.currentEventStartMinutes);

        this.hoursCount = (endTimestamp - startTimestamp) / 60;
        let percentageSlot = 100 / this.hoursCount;
        this.slotSize = percentageSlot / this.timeDivisor;

        this.setState({});
    }


    _onMouseClick(e){

    //    if (this.props.brokerFlag == "true") return;

        let currentSlot = this.state.currentSlot;
        var hours = Math.trunc(currentSlot / this.timeDivisor) + parseInt(this.currentEventStartHour);
        var minutes = (currentSlot % this.timeDivisor) * this.timePrecision + parseInt(this.currentEventStartMinutes);
        if (minutes >= 60){
            hours = hours + 1;
            minutes = minutes - 60;
        }

        let date = moment(parseInt(hours)+":"+parseInt(minutes), "hh:mm");
        let timeSlot = moment(date).format("HH:mm");
        let dateSlot = this.date;

        this.props.onMouseClick(dateSlot, timeSlot);
    }

    _onMouseEnter(e) {
        this.setState({popupVisible: true})
    }

    _onMouseLeave(e) {
        this.setState({popupVisible: false})
    }

    _onMouseMove(e) {
        let boundingBox = this.scheduleRef.current.getBoundingClientRect();
        this.start = boundingBox.left;
        this.top = e.screenY - boundingBox.top - boundingBox.height;
        let width = boundingBox.width;
        let slotWidth = (width / this.hoursCount) / this.timeDivisor;
        let currentSlot = Math.trunc((e.clientX - this.start + slotWidth / 2) / slotWidth);
        this.setState({ popupVisible: true, currentSlot: currentSlot, x: (e.clientX - this.start) / width, mouseX: e.clientX, mouseY: e.clientY});
    }


    render (){

        if (this.subject == undefined) return null;

        let currentSlot = this.state.currentSlot;
        let hours = Math.trunc(currentSlot / this.timeDivisor) + parseInt(this.currentEventStartHour);
        let minutes = ((currentSlot % this.timeDivisor) * this.timePrecision + parseInt(this.currentEventStartMinutes));
        if (minutes >= 60){
            hours = hours + 1;
            minutes = minutes - 60;
        }

        let date = moment(parseInt(hours)+":"+parseInt(minutes), "hh:mm");
        let timeSlot = moment(date).format("HH:mm");

        return ( 
         <div className="mainContainer" key={Math.random()}>
             {
                 this.labelsTime && this.labelsTime.map((v) => {
                     return <div key={Math.random()} className="timeLbl" style={{left: String(this.slotSize * this.timeDivisor * v.position)+'%'}}>|  {v.label}</div>
                 })
             }
            <div ref={this.scheduleRef} className="mainClass" style={{ cursor: this.props.readonly == true ? '' : 'copy' }}
                onMouseMove={this._onMouseMove.bind(this)}
                onMouseEnter={this._onMouseEnter.bind(this)}
                onMouseLeave={this._onMouseLeave.bind(this)}
                onClick={this._onMouseClick.bind(this)} >
            {
                this.props.lezioni && this.props.lezioni.map((lezione) => {

                    var dd = lezione.data.split(' ')[0];
                    var time = lezione.data.split(' ')[1].split(':');
                    var hh = time[0];
                    var mm = time[1];

                    if (dd != this.date) return null;

                    let startMeeting = (parseInt(hh) - parseInt(this.currentEventStartHour)) * this.timeDivisor;
                    startMeeting = startMeeting + (parseInt(mm) / this.timePrecision) - parseInt(this.currentEventStartMinutes) / this.timePrecision;
                    
                    return <SlotElem start={startMeeting} 
                            key={Math.random()}
                            insegnanti={this.props.insegnanti}
                            duration={parseInt(lezione.durata / this.timePrecision)} 
                            slotSize={this.slotSize} 
                            parent={this}
                            mouseEnter={() => this.setState({ mouseOnLesson: true })}
                            mouseLeave={() => this.setState({ mouseOnLesson: false })}
                            subject={this.subject}
                            meeting={lezione} />
                })
            }
            {
                this.props.eventi && this.props.eventi.map((evento) => {

                    var dd = evento.data.split(' ')[0];
                    var time = evento.data.split(' ')[1].split(':');
                    var hh = time[0];
                    var mm = time[1];

                    if (dd != this.date) return null;

                    let startMeeting = (parseInt(hh) - parseInt(this.currentEventStartHour)) * this.timeDivisor;
                    startMeeting = startMeeting + (parseInt(mm) / this.timePrecision) - parseInt(this.currentEventStartMinutes) / this.timePrecision;
                    
                    return <EventElem
                                start={startMeeting} 
                                key={Math.random()}
                                duration={parseInt(evento.durata / this.timePrecision)} 
                                slotSize={this.slotSize} 
                                parent={this}
                                subject={this.subject}
                                summary={evento.summary}
                            />
                })
            }
           
            </div>
            { (this.state.popupVisible && !this.state.mouseOnLesson && !this.props.readonly) &&
                <div className="popupSchedule" key={Math.random()}
                    style={{display: (this.state.popupVisible && !this.state.mouseOnLesson && !this.props.readonly) ? 'block' : 'none', 
                    left: this.state.mouseX - this.start, 
                    top: this.top}} >
                        {t('inserisci_lez')} {timeSlot}
                </div>
            }
        </div>
        )
    }
}

function SlotElem(props){

    var strAltriInsegnanti = '';
    props.insegnanti && props.meeting.altri_insegnanti.split(';').forEach(i => {
        if (i == '') return;
        var insegnante = props.insegnanti.find(temp => temp.id == i);
        if (insegnante == undefined) return;
        strAltriInsegnanti += ' - ' + insegnante.cognome;
    });

    return (<div key={Math.random()} className={"slotClass"} onMouseEnter={() => props.mouseEnter()} onMouseLeave={() => props.mouseLeave()} style={{ cursor: 'pointer',
        left: String(props.slotSize * props.start)+'%',
        width: String(props.slotSize * props.duration)+'%', maxWidth: String(props.slotSize * props.duration)+'%', marginRight: '2px', overflowX: 'scroll' }}
        >
            <div className="scheduleMeetingContent" >{props.meeting.cognome_ins != '' ? props.meeting.cognome_ins : props.meeting.nome_ins+ strAltriInsegnanti}<br/><b>{props.meeting.str_materia}</b></div>
    </div>
    );
}

function EventElem(props){

    return (
    <div key={Math.random()} className={"eventClass"} style={{
        left: String(props.slotSize * props.start)+'%',
        width: String(props.slotSize * props.duration)+'%', maxWidth: String(props.slotSize * props.duration)+'%', marginRight: '2px', overflowX: 'scroll' }}
        >
            <div className="scheduleMeetingContent" style={{ color: 'white', paddingLeft: 2, paddingRight: 2 }}>{props.summary}</div>
    </div>
    );
}

